import React, {useState} from "react";
import {
  Container,
  Content,
  ContentSortAndFilter,
  Title,
  OtherFiltersImageWrapper,
  ElParams,
  ImageWrapper,
} from "./styles";
import "react-tooltip/dist/react-tooltip.css";

import IconDollarFlowerActive from "../../assets/icons/sorterByCard/active/flower.svg";
import IconDollarFlowerDefault from "../../assets/icons/sorterByCard/default/flower.svg";
import IconPotentionGrowActive from "../../assets/icons/sorterByCard/active/globe.svg";
import IconPotentionGrowDefault from "../../assets/icons/sorterByCard/default/globe.svg";
import IconAttantionActive from "../../assets/icons/sorterByCard/active/warning.svg";
import IconEnergyActive from "../../assets/icons/sorterByCard/active/energy.svg";
import IconRussiaActive from "../../assets/icons/sorterByCard/active/russia.svg";
import IconGPBActive from "../../assets/icons/sorterByCard/active/gpb.svg";
import IconlaborateActive from "../../assets/icons/sorterByCard/active/lab.svg";
import IconlaborateDefault from "../../assets/icons/sorterByCard/default/lab.svg";
import urlMockImageCards from "../../assets/images/image.png";

import {SidebarTab} from "../Sidebar";
import IconsParams from "./IconsParams";
import {LoaderSkeleton} from "../SidebarCard/styles";
import {urlApi} from "../../helper/api";
import {ITypeRadar} from "../../types";
import {TBattery} from "../../pages/Dashboard/Dashboard.type";
import {getBatteryIconByPhase} from "../../helper/batteryIcons";
// import {LoaderSkeleton} from "../SidebarCard/styles";

interface IPropsImage {
  text?: string;
  image?: string;
  alt?: string;
  type?: "description" | "trends" | "regulations";
  src?: string;
}

const ImageWithFallback = ({src, alt, ...props}: IPropsImage) => {
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);

  const handleError = () => {
    setError(true);
  };

  const handleLoad = () => {
    setLoading(false);
  };

  return (
    <div style={{position: "relative", backgroundColor: "#1d2133"}}>
      {loading && !error && <LoaderSkeleton width="44px" height="44px" />}
      <img
        src={src}
        alt={alt}
        width={"100%"}
        height={"100%"}
        {...props}
        onError={handleError}
        onLoad={handleLoad}
        style={{
          opacity: loading || error ? 0 : 1,
          transition: "opacity 0.3s ease-in-out",
          display: error ? "none" : "block",
          borderRadius: "5px",
        }}
      />
      {error && (
        <img
          src={urlMockImageCards}
          alt="заглушка"
          width={"100%"}
          height={"100%"}
          style={{borderRadius: "5px"}}
          {...props}
        />
      )}
    </div>
  );
};

interface CardItemProps {
  // icon?: JSX.Element;
  invest_volume_tier?: number;
  market_volume_tier?: number;
  potential_volume_tier?: number;
  trl_tier?: number;
  title: string;
  isFlashFilterEnabled: boolean;
  isCritical: boolean | undefined;
  isNational: boolean | undefined;
  type: SidebarTab;
  onClick?: () => void;
  disableClusterInvestVolume?: boolean;
  disableClusterGrowthPotential?: boolean;
  disableClusterNational?: boolean;
  // disableTechTRL?: boolean;
  // disableTechMarketPotential?: boolean;
  // image?: string;
  isGpb?: boolean;
  imageCard?: string;
  isShowTitleParams?: boolean;
  imageCardAlt?: string;
  maturity?: string;
  typeRadar?: ITypeRadar;
  batteryRussia?: TBattery;
  batteryWorld?: TBattery;
  showBattery?: boolean;
}
const CardItem: React.FC<CardItemProps> = ({
  invest_volume_tier,
  title,
  isFlashFilterEnabled,
  isCritical,
  isNational,
  type,
  trl_tier,
  isGpb,
  potential_volume_tier,
  onClick,
  disableClusterInvestVolume = false,
  disableClusterGrowthPotential = false,
  disableClusterNational = false,
  imageCard,
  typeRadar,
  isShowTitleParams,
  market_volume_tier,
  imageCardAlt,
  maturity,
  batteryRussia,
  batteryWorld,
  showBattery = true,
}) => {
  const renderVolumeIcons = (
    volume: any,
    disabled: boolean,
    icon: any,
    iconActive: any,
    title: string
  ) => {
    const tooltipId = "investmentTooltip";
    return (
      <IconsParams
        tooltipId={tooltipId}
        tooltipContent={title}
        volume={volume}
        investVolume={volume}
        trl={trl_tier}
        activeIcon={icon}
        inactiveIcon={iconActive}
      />
    );
  };

  // const renderSettingsIcons = (disabled: boolean) => {
  //   if (settings) {
  //     return (
  //       <div style={{display: "flex", gap: 3}}>
  //         {[0, 1, 2].map((level) => (
  //           <IconWrapper key={level} disabled={disabled}>
  //             <img
  //               src={
  //                 level < settings
  //                   ? SettingsSmallIcon
  //                   : SettingsSmallDisabledIcon
  //               }
  //               width="100%"
  //               height="100%"
  //               alt={"alt"}
  //             />
  //           </IconWrapper>
  //         ))}
  //       </div>
  //     );
  //   }
  // };

  return (
    <Container onClick={onClick}>
      {/* {typeRadar === "map" && ( */}
      <ImageWrapper disabled={false}>
        {/* <img
          src={imageCard ? `${urlApi}/api${imageCard}` : urlMockImageCards}
          width={"100%"}
          height={"100%"}
          alt={"alt2"}
        /> */}
        <ImageWithFallback
          src={`${urlApi}/cms/techradar${imageCard}`}
          alt={imageCardAlt}
        />
      </ImageWrapper>
      {/* )} */}

      <Content>
        <Title>{title}</Title>
        <ContentSortAndFilter>
          {potential_volume_tier && (
            <ElParams isShowTitleParams={isShowTitleParams}>
              {renderVolumeIcons(
                potential_volume_tier,
                disableClusterGrowthPotential,
                IconPotentionGrowActive,
                IconPotentionGrowDefault,
                "Объем мирового рынка к 2030 г."
              )}
              <span>Прогноз мирового рынка к 2030</span>
            </ElParams>
          )}

          {invest_volume_tier ? (
            <ElParams isShowTitleParams={isShowTitleParams}>
              {renderVolumeIcons(
                invest_volume_tier,
                disableClusterInvestVolume,
                IconDollarFlowerActive,
                IconDollarFlowerDefault,
                "Объем мировых инвестиций 2023-2026 гг."
              )}
              <span>Инвестиционная активность в мире</span>
            </ElParams>
          ) : null}

          {market_volume_tier ? (
            <ElParams isShowTitleParams={isShowTitleParams}>
              {renderVolumeIcons(
                market_volume_tier,
                disableClusterInvestVolume,
                IconPotentionGrowActive,
                IconPotentionGrowDefault,
                "Объем мировых инвестиций 2023-2026 гг."
              )}
              <span>Объем мирового рынка</span>
            </ElParams>
          ) : null}

          {trl_tier && (
            <ElParams isShowTitleParams={isShowTitleParams}>
              {renderVolumeIcons(
                trl_tier,
                disableClusterGrowthPotential,
                IconlaborateActive,
                IconlaborateDefault,
                "Колба"
              )}
              <span>Уровень научной зрелости в России</span>
            </ElParams>
          )}
          {isFlashFilterEnabled && (
            <ElParams isShowTitleParams={isShowTitleParams} isSingle={true}>
              <OtherFiltersImageWrapper
                data-tooltip-id="growth_potential"
                data-tooltip-content="Потенциал роста"
                data-tooltip-place="top"
                disabled={disableClusterGrowthPotential}
              >
                <img
                  src={IconEnergyActive}
                  alt="Flash Filter"
                  width={"100%"}
                  height={"100%"}
                />
                {/* <Tooltip
                  id="growth_potential"
                  className="tooltip"
                  noArrow
                  offset={4}
                /> */}
              </OtherFiltersImageWrapper>
              <span>Потенциал роста</span>
            </ElParams>
          )}
          {/* {isGpb && (
            <ElParams isShowTitleParams={isShowTitleParams} isSingle={true}>
              <OtherFiltersImageWrapper
                data-tooltip-id="gbp"
                data-tooltip-content="Присутствие ГПБ"
                data-tooltip-place="top"
                disabled={false}
              >
                <img
                  src={IconGPBActive}
                  alt="Logo"
                  width={"100%"}
                  height={"100%"}
                />
              </OtherFiltersImageWrapper>
              <span>Присутствие ГПБ</span>
            </ElParams>
          )} */}
          {isCritical && (
            <ElParams isShowTitleParams={isShowTitleParams} isSingle={true}>
              <OtherFiltersImageWrapper
                data-tooltip-id="critical_card_2"
                data-tooltip-content="Критические и сквозные технологические кластеры в России, согласно Указу Президента РФ от 18.06.2024 № 529"
                data-tooltip-place="top"
              >
                <img
                  src={IconAttantionActive}
                  alt="Alarm Settings"
                  width={"100%"}
                  height={"100%"}
                />
                {/* <Tooltip
                  id="critical_card"
                  className="tooltip"
                  noArrow
                  offset={4}
                /> */}
              </OtherFiltersImageWrapper>
              <span>Критические технологические кластеры</span>
            </ElParams>
          )}
          {isNational && (
            <ElParams isShowTitleParams={isShowTitleParams} isSingle={true}>
              <OtherFiltersImageWrapper
                data-tooltip-id="national"
                data-tooltip-content="Технологические кластеры в составе Национальных проектов России"
                data-tooltip-place="top"
                disabled={disableClusterNational}
              >
                <img
                  src={IconRussiaActive}
                  alt="Russian"
                  width={"100%"}
                  height={"100%"}
                />
                {/* <Tooltip id="national" className="tooltip" noArrow offset={4} /> */}
              </OtherFiltersImageWrapper>
              <span>Кластеры в составе нац. проектов РФ</span>
            </ElParams>
          )}

           {showBattery &&
            batteryRussia !== "" &&
            batteryRussia !== null &&
            typeRadar === "map" && (
              <ElParams isShowTitleParams={isShowTitleParams} isSingle={true}>
                <OtherFiltersImageWrapper
                  data-tooltip-id="maturity"
                  data-tooltip-content={`Зрелость в России: ${batteryRussia}`}
                  data-tooltip-place="top"
                  disabled={disableClusterGrowthPotential}
                >
                  <img
                    src={getBatteryIconByPhase(batteryRussia)}
                    alt="Flash Filter"
                    width={"100%"}
                    height={"100%"}
                  />
                </OtherFiltersImageWrapper>
                <span>{batteryRussia}</span>
              </ElParams>
            )}

           {showBattery &&
            batteryWorld !== "" &&
            batteryWorld !== null &&
            typeRadar === "map" && (
              <ElParams isShowTitleParams={isShowTitleParams} isSingle={true}>
                <OtherFiltersImageWrapper
                  data-tooltip-id="maturity"
                  data-tooltip-content={`Зрелость в мире: ${batteryWorld}`}
                  data-tooltip-place="top"
                  disabled={disableClusterGrowthPotential}
                >
                  <img
                    src={getBatteryIconByPhase(batteryWorld)}
                    alt="Flash Filter"
                    width={"100%"}
                    height={"100%"}
                  />
                </OtherFiltersImageWrapper>
                <span>{batteryWorld}</span>
              </ElParams>
            )}

          {type !== SidebarTab.Clusters && (
            <ElParams isShowTitleParams={isShowTitleParams} isSingle={true}>
              renderVolumeIcons( trl, disableTechTRL, PotionActiveIcon,
              PotionIcon, "Уровень научной зрелости в России (патенты и
              публикации) за 2023-2026 гг." )
              <span>Объём мировогорынка к 2030г.</span>
            </ElParams>
          )}
        </ContentSortAndFilter>
      </Content>
    </Container>
  );
};

export default CardItem;
